import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { pick as _pick, pickBy as _pickBy, map as _map } from 'lodash';

import SelectList from '../components/Common/SelectList/SelectList';

import {
    fetchAvailablePlant,
    setAvailablePlant,
    setNewBookingPlant,
} from '../actions/newBooking';

const regoFunc = (item) => item.rego;

class PlantSelectorContainer extends Component {
    componentDidMount() {
        const { availablePlant, startTime, endTime, plantTypeId, driverId, pickupLocationId } = this.props;
        // Only fetch if we don't already have the available plant
        if (Object.keys(availablePlant).length === 0)
            this.props.fetchAvailablePlant(startTime, endTime, plantTypeId, driverId, pickupLocationId);
    }

    render() {
        return (
            <SelectList
                title="Select Plant"
                items={this.props.availablePlant}
                subValueFunc={regoFunc}
                customSortBy={this.props.sortByPriority}
                selectedItemId={this.props.plantId}
                setSelectedItem={this.props.setNewBookingPlant}
            />
        );
    }
}

function mapStateToProps(state) {
    let { availablePlantIds } = state.newBooking;
    const { plantId, startTime, endTime, plantTypeId, plantType, pickupLocationId } = state.newBooking;
    const { plant } = state.entities;
    const { personId } = state.environment.user;

    const availablePlant = _pick(plant, availablePlantIds);

    // Pull out the ids for sorting by api order
    availablePlantIds = _map(availablePlant, function(plant) {
        return plant.id;
    });

    // Keep the ordering defined by the API
    const sortByPriority = (item) => availablePlantIds.indexOf(item.id);

    return {
        startTime,
        endTime,
        plantTypeId,
        plantType,
        driverId: personId,
        pickupLocationId,
        plantId,
        availablePlant,
        sortByPriority,
    };
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        fetchAvailablePlant,
        setAvailablePlant,
        setNewBookingPlant
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(PlantSelectorContainer);



// WEBPACK FOOTER //
// ./scripts/containers/PlantSelectorContainer.jsx